export enum SmartSearchFilterValues{
    AllPages = 0,
    Products = 1,
    DownloadSupportAccount,
    VideosBlogposts = 3
}